import {BaseSpringServiceCB} from '@aiknow-srl/aik-ngx-http';
import {AuthOPEEnum} from "./AuthOPEEnum";

/**
 * I inner class
 */
class I {
  /**
   * Old password
   */
  oldPassword!: string;
  /**
   * new password
   */
  newPassword!: string;
}

/**
 * O inner class
 */

class O {

}


/**
 * put reseller class
 */

export class ChangeUserPasswordCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**
   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor() {
    super(AuthOPEEnum.ChangeUserPassword);
    this.i = new I();
    this.o = new O();
  }

}
